export default {
  ACCELERATED: 'accelerated',
  EXTENDED: 'extended',
}
